import { render } from "./tabsIcon.vue?vue&type=template&id=7e540cb9"
import script from "./tabsIcon.vue?vue&type=script&lang=js"
export * from "./tabsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__